import { render, staticRenderFns } from "./orderSubscription.vue?vue&type=template&id=74b52401&"
import script from "./orderSubscription.vue?vue&type=script&lang=js&"
export * from "./orderSubscription.vue?vue&type=script&lang=js&"
import style0 from "./orderSubscription.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports